import { useState, useEffect } from 'react';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000';

// Convierte rutas relativas de imagen (/uploads/...) en URLs absolutas
export function resolverImagen(url) {
  if (!url) return null;
  if (url.startsWith('http')) return url;       // ya es absoluta
  if (url.startsWith('/')) return BASE + url;   // relativa → añadir base
  return url;
}

export function useApi(path, deps = []) {
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  useEffect(() => {
    setLoading(true);
    fetch(`${BASE}${path}`)
      .then(r => r.json())
      .then(d => { setData(d); setLoading(false); })
      .catch(e => { setError(e.message); setLoading(false); });
  }, deps);

  return { data, loading, error };
}